// -*- mode: jsx;-*-
import { PageLink } from './pagination.js';


export const EndOfListMessage = (props) =>
    // The PageLink this renders seems to be broken (it doesn't actually return you to the start, or have any apparent
    // effect at all). See WS-31742.

        <div className="end-of-list-messaging">
            <h2>Oops, you reached the end of this list.</h2>

            <div className="pagination">
                <ul className="pages">
                    <PageLink {...props}
                        page={1}
                        text="Go back to the start"
                        key="Go back to the start"
                        selected={false}
                        rel={null} />
                </ul>
            </div>

        </div>
;
